const resource = '/v1/applications';

export default $axios => ({
  index(payload) {
    return $axios.get(`${resource}`, {params: payload});
  },

  show(appId) {
    return $axios.get(`${resource}/application-detail/${appId}`);
  },

  checkCanDownload(appUserId) {
    return $axios.get(`${resource}/payment/check/${appUserId}`);
  },

  getListForUser(payload) {
    const page = payload !== undefined && payload.page > 0 ? payload.page : 1;
    return $axios.get(`${resource}/list-for-user?page=${page}`, {params: payload});
  },
  getAllForUser() {
    return $axios.get(`${resource}/all-for-user`);
  },

  getRandomPublishApplications() {
    return $axios.get(`${resource}/list-random-publish-applications`);
  },

  checkLimitAppUser(appId) {
    return $axios.post(`${resource}/check-limit-app-user/${appId}`);
  },

  use(appId) {
    return $axios.post(`${resource}/use`, {
      app_id: appId
    });
  },

  findApplicationForUser(idEncrypt) {
    return $axios.get(`${resource}/find-for-user/${idEncrypt}`);
  },

  saveAnswer(payload) {
    return $axios.post(`${resource}/save-answer`, payload);
  },

  downloadDocFiles(payload) {
    return $axios.post(`${resource}/download-doc-files`, payload);
  },

  downloadGuideFiles(appUserIdEncrypt) {
    return $axios.post(`${resource}/download-guides`, {
      app_user_id: appUserIdEncrypt
    });
  },

  downloadDocumentGuideByAppId(appId) {
    return $axios.post(`${resource}/download-guides-by-app-id`, {
      app_id: appId
    });
  },

  deleteApplicationUser(id) {
    return $axios.delete(`${resource}/delete-application-user/${id}`);
  },

  getAddressByPostalCode(code) {
    return $axios.get(`${resource}/get-address-by-postal-code`, {params: {
      post_code: code
    }});
  },

  receipt() {
    return $axios.get(`${resource}/receipt`);
  },

  findById(appId) {
    return $axios.get(`${resource}/find-by-id/${appId}`);
  },

  getTags() {
    return $axios.get(`${resource}/tags`);
  },

  pingAdminTransfer(payload) {
    return $axios.post(`v1/ping-admin-transfer`, payload);
  }
});
